import React, { Fragment } from "react";
import PropTypes from "prop-types";
import GeneesmiddelComponent from "../shared/GeneesmiddelComponent";
import Fieldset from "../common/Fieldset";

const GeneesmiddelDetailForm = (props) => {
    const {
        model
    } = props;

    return <Fragment>
        <Fieldset>
            <GeneesmiddelComponent model={model} />
        </Fieldset>
    </Fragment>;
};

GeneesmiddelDetailForm.propTypes = {
    model: PropTypes.object
};

export default GeneesmiddelDetailForm;